import cx from 'classnames';
import React from 'react';

import { useLocationContext } from '../../context/LocationContext';

type Props = {
  children?: React.ReactNode;
};

export default function LocationDisplay({ children }: Props) {
  const { isDeliveryAllowed = true } = useLocationContext();

  return (
    <div
      data-qa="availability-info"
      data-testid="availability-info"
      className={cx(
        'flex flex-col items-center s:max-m:px-24 m:justify-center',
        {
          'bg-white': isDeliveryAllowed,
          's:max-m:h-screen': isDeliveryAllowed,
          's:max-m:pt-32': isDeliveryAllowed
        }
      )}
    >
      {children}
    </div>
  );
}
